import { Checkbox, CheckboxGroup } from "@heroui/react";
import { Controller, useFormContext } from "react-hook-form";

function CheckboxGroupInput({
    name,
    options,
    label,
    orientation = "vertical",
}: {
    name: string;
    options: { id: string | number; description: string | number }[];
    label?: string;
    orientation?: "horizontal" | "vertical";
}) {
    const f = useFormContext();
    return (
        <Controller
            name={name}
            control={f.control}
            render={({ field: { value, onChange, onBlur } }) => {
                return (
                    <CheckboxGroup
                        label={label}
                        orientation={orientation}
                        value={value}
                        onValueChange={onChange}
                        onBlur={onBlur}
                    >
                        {options?.map((option) => {
                            return (
                                <Checkbox
                                    key={option.id}
                                    value={option.id.toString()}
                                >
                                    {option.description}
                                </Checkbox>
                            );
                        })}
                    </CheckboxGroup>
                );
            }}
        />
    );
}

export default CheckboxGroupInput;
